import { Auth } from "aws-amplify"
import { NotificationManage } from "../components/NotificationManage"
import filter from "../containers/Function/Rudeword.function"
import AWS from "aws-sdk"
import config from "../config"

export async function handlefb(data) {
	const { accessToken: token, expiresIn } = data
	const expires_at = expiresIn * 1000 + new Date().getTime()
	const user = await new Promise((resolve, reject) => {
		window.FB.api(
			`/me/?fields=id,first_name,last_name,email,picture`,
			function (response) {
				if (response && !response.error) {
					/* handle the result */
					resolve(response)
				}
			}
		)
	})
	let result, response
	try {
		response = await Auth.federatedSignIn(
			"facebook",
			{ token, expires_at },
			user
		)
		result = await Auth.currentAuthenticatedUser({
			bypassCache: false
		})
	} catch (err) {
		throw err
	}
	return { result, response }
}

export async function handlegm(googleUser) {
	const { id_token, expires_in } = googleUser.getAuthResponse()
	const expires_at = expires_in * 1000 + new Date().getTime()
	const profile = googleUser.getBasicProfile()
	let user = {
		email: profile.getEmail(),
		given_name: profile.getGivenName(),
		family_name: profile.getFamilyName(),
		image: profile.getImageUrl()
	}
	let result, response
	try {
		response = await Auth.federatedSignIn(
			"google",
			{ token: id_token, expires_at },
			user
		)
		result = await Auth.currentAuthenticatedUser({
			bypassCache: false
		})
	} catch (err) {
		throw err
	}
	return { result, response }
}

export async function handleln(data) {
	const { token, user, expiresIn } = data
	let result, response
	try {
		response = await Auth.federatedSignIn(
			"dev-ayzgkh29.eu.auth0.com",
			{ token, expires_at: expiresIn },
			user
		)
		result = await Auth.currentAuthenticatedUser({
			bypassCache: false
		})
	} catch (err) {
		throw err
	}
	return { result, response }
}

export async function handleloginlocal(username, password, t) {
	try {
		const user = await Auth.signIn(username, password)
		if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
			return user.challengeName
		} else {
			let session = await handlerestoreSession()
			return session
		}
	} catch (err) {
		if (err.code === "UserNotConfirmedException") {
			NotificationManage(
				"error",
				`${t("NotificationManager.Login.unconfirmed")}`,
				`${t("NotificationManager.status.Failure")}`
			)
		} else if (err.code === "PasswordResetRequiredException") {
			// The error happens when the password is reset in the Cognito
			// In this case you need to call forgotPassword to reset the password
			// Please check the Forgot Password part.
		} else if (err.code === "NotAuthorizedException") {
			NotificationManage(
				"error",
				`${t("NotificationManager.Login.incorrect")}`,
				`${t("NotificationManager.status.Failure")}`
			)
		} else if (err.code === "UserNotFoundException") {
			NotificationManage(
				"error",
				`${t("NotificationManager.Login.notexist")}`,
				`${t("NotificationManager.status.Failure")}`
			)
		} else {
			NotificationManage(
				"error",
				`${t("NotificationManager.status.emessage")} ${err.message}`,
				`${t("NotificationManager.status.Failure")}`
			)
		}
		throw err
	}
}

export async function handlelogoutlocal() {
	let result = await Auth.signOut()
		.then((data) => {
			return data
		})
		.catch((err) => {
			throw err
		})
	return result
}

export async function handlerestoreSession() {
	const cognitoUser = await Auth.currentAuthenticatedUser({ bypassCache: true })
	let result, Credentials
	if (!!cognitoUser) {
		try {
			Credentials = await Auth.currentCredentials()
			result = { Credentials, cognitoUser }
		} catch (error) {}
	} else {
		NotificationManage("error", "Session expired, Please login again", "Error")
	}
	return { result }
}

export async function handlesignupuser(data, t) {
	const {
		password,
		given_name,
		family_name,
		researchArea,
		accepted_news
	} = data
	const username = data.email
	await Auth.signUp({
		username,
		password,
		attributes: {
			given_name: filter.clean(given_name),
			family_name: filter.clean(family_name),
			phone_number: "",
			"custom:country": "",
			"custom:organisation": "",
			"custom:occupation": "",
			"custom:department": "",
			"custom:research_field": researchArea,
			"custom:accepted_news": `${accepted_news}`
		}
	})
		.then((data) => {
			NotificationManage(
				"info",
				`${t("NotificationManager.user.verify")}`,
				`${t("NotificationManager.status.info")}`
			)
		})
		.catch((err) => {
			NotificationManage(
				"error",
				`${t("NotificationManager.status.emessage")} ${err.message}`,
				`${t("NotificationManager.status.Error")}`
			)
			throw err
		})
}

export async function handlenewpasswordreq(data, newPassword) {
	const { password } = data
	const username = data.email
	let result = await Auth.signIn(username, password)
		.then((user) => {
			let res
			if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
				res = Auth.completeNewPassword(user, newPassword)
					.then((user) => {
						return user
					})
					.catch((err) => {
						throw err
					})
			}
			return res
		})
		.catch((err) => {})
	return result
}

export async function handleforgotpassword(username) {
	await Auth.forgotPassword(username)
		.then((data) => {
			return data
		})
		.catch((err) => {
			throw err
		})
}

export async function handleresetpassword(username, code, new_password) {
	await Auth.forgotPasswordSubmit(username, code, new_password)
		.then((data) => {
			return data
		})
		.catch((err) => {
			throw err
		})
}

export async function handleresendverification(username) {
	await Auth.resendSignUp(username)
		.then((data) => {
			return data
		})
		.catch((err) => {
			throw err
		})
}

export async function handleupdateuserattribute(info) {
	let user = await Auth.currentAuthenticatedUser({ bypassCache: true })
	let result = await Auth.updateUserAttributes(user, info)
		.then((data) => {
			if (data === "SUCCESS") {
				return handlerestoreSession()
			}
		})
		.catch((err) => {
			throw err
		})
	return result
}

export async function handleuserobject() {
	let objects = {}
	objects.s3 = new AWS.S3({
		s3ForcePathStyle: true,
		params: { Bucket: config.s3.BUCKET }
	})
	return { objects }
}

export async function handlechangepassword(data) {
	const { currentpassword, newpassword } = data
	await Auth.currentAuthenticatedUser()
		.then((user) => {
			return Auth.changePassword(user, currentpassword, newpassword)
		})
		.then((data) => {
			if (data === "SUCCESS") {
				return handlerestoreSession()
			}
		})
		.catch((err) => {
			throw err
		})
}

export const profileImageValidator = (payload, status) => {
	let checkImage = "/login.png"
	if (status === "get_user") {
		if (!!payload.profile_picture) {
			if (payload.profile_picture !== "-") {
				checkImage = payload.profile_picture
			}
		} else if (!!payload.image) {
			checkImage = payload.checkImage
		}
	} else if (status === "restore") {
		if (!!payload.result.cognitoUser.image) {
			checkImage = payload.result.cognitoUser.image
		}
		if (!!payload.result.cognitoUser.picture) {
			checkImage = payload.result.cognitoUser.picture
			if (!!payload.result.cognitoUser.picture.data)
				checkImage = payload.result.cognitoUser.picture.data.url
		}
	}
	return checkImage
}

export const givenNameFamilyNameValidator = (payload, status) => {
	let given_name = ""
	let family_name = ""
	if (status === "get_user") {
		if (!!payload.first_name) {
			given_name = payload.first_name
			family_name = payload.last_name
		} else {
			given_name = payload.given_name
			family_name = payload.family_name
		}
	} else if (status === "restore") {
		if (!!payload.result.cognitoUser.first_name) {
			given_name = payload.result.cognitoUser.first_name
			family_name = payload.result.cognitoUser.last_name
		} else {
			given_name = payload.result.cognitoUser.given_name
			family_name = payload.result.cognitoUser.family_name
		}
	}
	return { given_name, family_name }
}
